__turbopack_context__.v({
  "className": "goudyini_55e115cf-module__24TAbW__className",
  "variable": "goudyini_55e115cf-module__24TAbW__variable",
});
